import { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { toast } from 'react-toastify';
import { selectAccountChannelsMap, updateSpace } from '~/store';

const PRIVATE = 'private';
const PUBLIC = 'public';

const ACCESS_MODE = [
  {
    value: PUBLIC,
    displayName: 'Open: available to all users in the account',
  },
  {
    value: PRIVATE,
    displayName: 'Restricted: limited to specific people',
    notes: [
      'Users added to this space will be able to perform actions related to their account role.',
      'You do not need to add guests to this space. Guest can access any broadcast they are invited to.',
    ],
  },
];

const UsersTab = () => {
  const dispatch = useDispatch();
  const { spaceToken } = useParams();
  const spacesMap = useSelector(selectAccountChannelsMap);
  const space = spacesMap[spaceToken];
  const [spaceAccessMode, setSpaceAccessMode] = useState(space?.isPrivate ? PRIVATE : PUBLIC);

  const onSpacesAccessChange = useCallback(
    async ({ target }) => {
      const isPrivate = target.value === PRIVATE;
      setSpaceAccessMode(target.value);

      try {
        await dispatch(
          updateSpace({ id: space.id, data: { isPrivate }, trigger: 'SpaceUsersTab@onSpacesAccessChange' })
        ).unwrap();
      } catch {
        toast.error('Failed to change space access');
        setSpaceAccessMode(isPrivate ? PUBLIC : PRIVATE);
      }
    },
    [dispatch, space]
  );

  if (!space) return null;

  return (
    <div className="flex flex-col text-left">
      <b>Space Access</b>

      <fieldset className="form-radio-group">
        {ACCESS_MODE.map((mode) => (
          <div key={mode.value}>
            <label className="form-radio-label p-2 flex" htmlFor={`space-access-${mode.value}`}>
              <input
                id={`space-access-${mode.value}`}
                className="mr-2"
                name="space-access"
                type="radio"
                value={mode.value}
                onChange={onSpacesAccessChange}
                checked={spaceAccessMode === mode.value}
              />
              {mode.displayName}
            </label>

            {mode.notes && (
              <div className="text-xs pl-7">
                {mode.notes.map((note) => (
                  <p key={note}>{note}</p>
                ))}
              </div>
            )}
          </div>
        ))}
      </fieldset>
    </div>
  );
};

UsersTab.propTypes = {};

export default UsersTab;
